/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Cap_Invoke_Api_Use_DescInputs */



/**
* | output |
* | --- |
* | "Allows using the invoke_api meta-tools to call uploaded API descriptions." |
*
* @param {Rights_Cap_Invoke_Api_Use_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_cap_invoke_api_use_desc = /** @type {((inputs?: Rights_Cap_Invoke_Api_Use_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Cap_Invoke_Api_Use_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erlaubt die Nutzung der invoke_api-Meta-Tools zum Aufruf hochgeladener API-Beschreibungen.")
	return /** @type {LocalizedString} */ ("Allows using the invoke_api meta-tools to call uploaded API descriptions.")
});